/* eslint-disable import/prefer-default-export */
export const BLOCK_POSITION: { [key: string]: string } = {
  left: 'left',
  right: 'right',
};
